import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../..";
import { ICategories } from "./types";

interface TrackingState {
  consents: ICategories;
  dirty: boolean;
  isConfigured: boolean;
}

const initialState = {
  consents: { All: false, functional: true, "Segment.io": true },
  dirty: false,
  dialog: {
    open: false,
  },
  isConfigured: false,
} as TrackingState;

export const trackingSlice = createSlice({
  name: "tracking",
  initialState,
  reducers: {
    setConsent: (
      state,
      action: PayloadAction<{ name: keyof ICategories; enabled: boolean }>,
    ) => {
      state.consents[action.payload.name] = action.payload.enabled;

      state.dirty = true;
    },
    acceptAllConsents: (state) => {
      state.consents = {
        All: true,
        "Segment.io": true,
        functional: true,
      };

      state.dirty = false;

      // Reload the page to load any third parties.
      // We only do this if the user has previously configured consents.
      if (state.isConfigured) {
        window.location.reload();
      }

      state.isConfigured = true;
    },
    rejectAllConsents: (state) => {
      state.consents = { All: false, functional: false, "Segment.io": true };

      state.dirty = false;

      // Reload the page to clear any third parties.
      // We only do this if the user has previously configured consents.
      if (state.isConfigured) {
        window.location.reload();
      }

      state.isConfigured = true;
    },
    rejectIosAppTrackingTransparency: (state) => {
      state.consents = { All: false, functional: true, "Segment.io": true };

      state.dirty = false;

      // Reload the page to clear any third parties.
      // We only do this if the user has previously configured consents.
      if (state.isConfigured) {
        window.location.reload();
      }

      state.isConfigured = true;
    },
    confirmConfiguration: (state) => {
      state.isConfigured = true;

      // Reload the page if dirty to clear/load any third parties
      const shouldReload = state.dirty;

      if (shouldReload) {
        window.location.reload();
      }

      state.dirty = false;
    },
  },
});

export const {
  setConsent,
  acceptAllConsents,
  rejectAllConsents,
  rejectIosAppTrackingTransparency,
  confirmConfiguration,
} = trackingSlice.actions;

export const selectTrackingConsents = (state: RootState) =>
  state.tracking.consents;

export const selectTrackingIsConfigured = (state: RootState) =>
  state.tracking.isConfigured;

export default trackingSlice.reducer;
